import { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { UserStorageSelectors } from 'reactApp/modules/user/userStorage';
import { sendDwh } from 'reactApp/utils/ga';

import { EDITOR_RESTRICTION_TOOLTIP_ID } from './EditorRestrictionTooltip';

interface UseEditorRestrictionTooltipProps {
    isEditingDisabled: boolean;
}

export function useEditorRestrictionTooltip({ isEditingDisabled }: UseEditorRestrictionTooltipProps) {
    const tooltipRef = useRef<HTMLDivElement | null>(null);
    const [showTooltip, setShowTooltip] = useState(false);

    const editorRestrictionTooltipShown = Boolean(useSelector((state) => UserStorageSelectors.get(state, EDITOR_RESTRICTION_TOOLTIP_ID)));
    const handleCloseTooltip = useCallback(() => {
        setShowTooltip(false);
    }, []);

    const handleClick = useCallback(() => {
        emitAnalyticEvent(AnalyticEventNames.EDITOR_BUTTON_CLICK);
        sendDwh({ eventCategory: 'button', action: 'click', dwhData: { button_name: 'edit_files', source: 'desktop', platform: 'web' } });
        setShowTooltip(isEditingDisabled);
    }, [isEditingDisabled]);

    useEffect(() => {
        setShowTooltip(isEditingDisabled && !editorRestrictionTooltipShown);
    }, [isEditingDisabled]);
    return {
        tooltipRef,
        showTooltip,
        handleCloseTooltip,
        handleClick,
    } as const;
}
